import { v4 as uuidv4 } from 'uuid';

import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RatingSummary } from '../../../../vtex-apps/peer/reviews-and-ratings/RatingSummary/default';
import { Wishlist } from '../../../../vtex-apps/peer/wishlist/Wishlist/default';
import { ResponsiveLayoutDesktop } from '../../../../vtex-apps/responsive-layout/ResponsiveLayoutDesktop/default';
import { ResponsiveLayoutMobile } from '../../../../vtex-apps/responsive-layout/ResponsiveLayoutMobile/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { ProductImages } from '../../../../vtex-apps/store-components/ProductImages/default';
import { ProductIdentifier } from '../../../../vtex-apps/product-identifier/ProductIdentifier/default';
import { ProductName } from '../../../../vtex-apps/store-components/ProductName/default';
import { ProductHighlights } from '../../../../vtex-apps/product-highlights/ProductHighlights/default';
import { SkuSelector } from '../../../../vtex-apps/store-components/SkuSelector/default';
import { ProductSellingPrice } from '../../../../vtex-apps/product-price/ProductSellingPrice/default';
import { ProductQuantity } from '../../../../vtex-apps/product-quantity/ProductQuantity/default';
import { ShippingSimulator } from '../../../../vtex-apps/store-components/ShippingSimulator/default';
import { AddToCartButton } from '../../../../vtex-apps/add-to-cart-button/AddToCartButton/default';
import { Share } from '../../../../vtex-apps/store-components/Share/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { AvailabilityNotify } from '../../../../vtex-apps/AvailabilityNotify/default';
import { ConditionLayoutProduct } from '../../../../vtex-apps/ConditionLayoutProduct/default';
import { SellerTable } from '../../../../vtex-apps/seller-selector/SellerTable/default';
import { SellerSimulateShipping } from '../../../../vtex-apps/seller-selector/SellerSimulateShipping/default';
import { ProductListPrice } from '../../../../vtex-apps/product-price/ProductListPrice/default';

export default function ProductImagesDetailsGroup() {
	return {
		componentName: 'SellerTable',
		componentId: uuidv4(),
		componentGroup: 'ProductImagesDetailsGroup',
		props: SellerTable({ mzTitle: 'MZ | Bloco principal' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'product-wrapper__pidg-1',
					marginTop: 9,
					marginBottom: 9,
					preserveLayoutOnMobile: false,
				},
				[
					FlexLayoutCol(
						{
							width: { desktop: '60%', tablet: '100%', phone: '100%' },
							blockClass: 'product-image-dg-left__flex-col-pidg-1',
							mzTitle: 'MZ | Bloco  Esquerda',
							preventVerticalStretch: true,
						},
						[
							Wishlist({ blockClass: 'product-wishlist__pidg-1' }),
							ProductImages({
								blockClass: 'product-images__pidg-1',
								showPaginationDots: 'always',
								maxHeight: 600,
							}),
							ResponsiveLayoutDesktop({}, [tipBarDesktop]),
						],
					),
					FlexLayoutCol(
						{
							width: { desktop: '40%', tablet: '100%', phone: '100%' },
							blockClass: 'product-image-dg-right__flex-col-pidg-1',
							mzTitle: 'MZ | Bloco  Direita',
						},
						[
							ProductIdentifier(),
							FlexLayoutRow(
								{
									blockClass: 'product-highlights-wrapper__pidg-1',
									preventHorizontalStretch: true,
								},
								[ProductHighlights({ blockClass: 'product-highlights__pidg-1' })],
							),
							FlexLayoutRow({}, [ProductName({ blockClass: 'product-name__pidg-1' })]),
							RatingSummary({
								blockClass: 'product-reviewsSummary__pidg-1',
							}),
							ConditionLayoutProduct({
								Then: FlexLayoutRow({ blockClass: 'available-row__pidg-1' }, [
									FlexLayoutCol({}, [
										FlexLayoutRow(
											{
												blockClass: 'product-price-row__pidg-1',
												colSizing: 'equal',
												preserveLayoutOnMobile: true,
											},
											[
												ProductListPrice({
													message: '{listPriceValue}',
													blockClass: 'product-list-price__pidg-1',
												}),
												ProductSellingPrice({
													messsage: '{sellingPriceValue}',
													blockClass: 'product-selling-price__pidg-1',
												}),
											],
										),
										SkuSelector({
											blockClass: 'skuSelector__pidg-1',
											imageHeight: 64,
											imageWidth: 64,
										}),
										FlexLayoutRow({ blockClass: 'add-to-cart-row__pidg-1', colSizing: 'auto' }, [
											ProductQuantity({ blockClass: 'add-to-cart-quantity__pidg-1' }),
											AddToCartButton({
												blockClass: 'add-to-cart-button__pidg-1',
												text: 'COMPRAR AGORA',
												customToastUrl: '/checkout/#/cart',
											}),
										]),
										ConditionLayoutProduct({
											conditions: [
												{
													subject: 'hasMoreSellersThan',
													arguments: {
														quantity: 1,
													},
												},
											],
											Then: SellerSimulateShipping(),
											Else: ShippingSimulator(),
										}),
									]),
								]),
								Else: FlexLayoutRow(
									{
										blockClass: 'not-available-row__pidg-1',
									},
									[
										FlexLayoutCol({}, [
											//adicionar seletor de sku aqui

											SkuSelector({
												blockClass: 'skuSelector__pidg-1',
												imageHeight: 64,
												imageWidth: 64,
											}),
											AvailabilityNotify(),
										]),
									],
								),
							}),
							Share({
								blockClass: 'share__pidg-1',
								shareLabelClass: 'share-label__pidg-1',
								buttonsContainerClass: 'share-btn-container__pidg-1',
							}),
							ResponsiveLayoutMobile({}, [tipBarMobile]),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--text-color-1', to: '--pidg-1-text-color', name: 'General Text' },
			{ from: '--text-color-1', to: '--pidg-1-reviews-color', name: 'Reviews' },
			{ from: '--cta-color-pure', to: '--pidg-1-cta-color', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--pidg-1-cta-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--pidg-1-cta-focus', name: 'CTA Active' },
			{ from: '--white', to: '--pidg-1-cta-text-color', name: 'CTA Text Color' },
			{ from: '--text-color-1', to: '--pidg-1-list-price-color', name: 'List Price' },
			{ from: '--text-color-1', to: '--pidg-1-price-color', name: 'Price' },
			{ from: '--text-color-1', to: '--pidg-1-installments-color', name: 'Installments' },
			{ from: '--cta-color-hover', to: '--pidg-1-discount-bg-color', name: 'Discount Background' },
			{ from: '--white', to: '--pidg-1-discount-text-color', name: 'Discount text' },
			{ from: '--brand-color-primary-pure', to: '--pidg-1-sku-detail-color', name: 'SKU selecionado' },
			{ from: '--brand-color-primary-pure', to: '--pidg-1-sku-text-color', name: 'SKU Text' },
			//sku hover
			{ from: '--neutral-color-high-light', to: '--pidg-1-sku-hover-bg-color', name: 'SKU Hover' },
			{ from: '--brand-color-primary-pure', to: '--pidg-1-quantity-detail-color', name: 'Select Quantity' },
			{ from: '--text-color-1', to: '--pidg-1-quantity-text-color', name: 'Quantity Text' },
			{ from: '--cta-color-pure', to: '--pidg-1-flag-color', name: 'Highlight Background' },
			{ from: '--white', to: '--pidg-1-highlight-text-color', name: 'Highlight Text' },
			{ from: '--cta-color-pure', to: '--pidg-1-slider-color', name: 'Slider' },
			{ from: '--neutral-color-high-light', to: '--pidg-1-freight-bg-color', name: 'Freight Background' },
			{ from: '--text-color-1', to: '--pidg-1-freight-header-color', name: 'Freight Header Text' },
			{ from: '--text-color-1', to: '--pidg-1-freight-body-color', name: 'Freight Body Text' },
			{ from: '--text-color-1', to: '--pidg-1-tipbar-text-color', name: 'Tipbar Text' },
			{ from: '--text-color-1', to: '--pidg-1-link-text-color', name: 'Tipbar Link Text' },
			{ from: '--text-color-1', to: '--pidg-1-gift-title-color', name: 'Gift Titles' },
			{ from: '--text-color-1-light', to: '--pidg-1-gift-description-color', name: 'Gift Description' },
			{ from: '--text-color-1', to: '--pidg-1-gift-qtd-color', name: 'Gift Qtd' },
			{ from: '--neutral-color-high-light', to: '--pidg-1-gift-bg-color', name: 'Gift Background' },
			{ from: '--white', to: '--pidg-1-gift-item-bg-color', name: 'Gift Item Background' },
			{ from: '--support-color-2', to: '--pidg-1-card-price-bg-color', name: 'Card Price Background' },
			{ from: '--brand-color-primary-pure', to: '--pidg-1-wishlist', name: 'wishlist' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-none', to: '--pidg-1-br', name: 'Details' },
			{ from: '--border-radius-none', to: '--pidg-1-image-br', name: 'Image' },
			{ from: '--border-radius-none', to: '--pidg-1-cta-br', name: 'CTA, input e Quantity' },
			{ from: '--border-radius-none', to: '--pidg-1-slider-br', name: 'Slider Dots' },
			{ from: '--border-radius-none', to: '--pidg-1-shipping-br', name: 'Shipping box' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-nano', to: '--pidg-1-highlight-size', name: 'Highlight' },
			{ from: '--spacing-sm', to: '--pidg-1-sku-height', name: 'Sku Selector Height' },
			{ from: '--spacing-sm', to: '--pidg-1-cta-size', name: 'CTA/Qty/Freight' },
			{ from: '--spacing-sm', to: '--pidg-1-dot-width', name: 'Dot Width' },
			{ from: '--spacing-nano', to: '--pidg-1-dot-height', name: 'Dot height' },
			{ from: '--spacing-sm', to: '--pidg-1-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--pidg-1-dot-height-active', name: 'Dot Height Active' },
			{ from: '--spacing-nano', to: '--pidg-1-sku-gap', name: 'Espaçamento SKU' },
			{ from: '--spacing-nano', to: '--pidg-1-shippingY-gap', name: 'Shipping box Y' },
			{ from: '--spacing-nano', to: '--pidg-1-shippingX-gap', name: 'Shipping box X' },
			//tipbar lateral spacing
			{ from: '--spacing-xxxs', to: '--pidg-1-tipbar-lateral-spacing', name: 'Tipbar Lateral Spacing' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--pidg-1-text-fs', name: 'General Text' },
			{ from: '--font-size-lg', to: '--pidg-1-product-name-fs', name: 'Product Name' },
			{ from: '--font-size-xs', to: '--pidg-1-highlight-fs', name: 'Highlight' },
			{ from: '--font-size-xs', to: '--pidg-1-list-price-fs', name: 'List Price' },
			{ from: '--font-size-lg', to: '--pidg-1-price-fs', name: 'Price' },
			{ from: '--font-size-xs', to: '--pidg-1-discount-fs', name: 'Discount' },
			{ from: '--font-size-xs', to: '--pidg-1-installments-fs', name: 'Installments' },
			{ from: '--font-size-xs', to: '--pidg-1-sku-selector-fs', name: 'Sku Selector' },
			{ from: '--font-size-md', to: '--pidg-1-cta-fs', name: 'CTA' },
			{ from: '--font-size-sm', to: '--pidg-1-freight-header-fs', name: 'Freight Head' },
			{ from: '--font-size-xs', to: '--pidg-1-freight-body-fs', name: 'Highlight Body' },
			{ from: '--font-size-xs', to: '--pidg-1-tipbar-fs', name: 'Tipbar' },
			{ from: '--font-size-xs', to: '--pidg-1-link-fs', name: 'Tipbar Link' },
			{ from: '--font-size-md', to: '--pidg-1-gift-title-fs', name: 'Gift Title Size' },
			{ from: '--font-size-sm', to: '--pidg-1-gift-product-title-fs', name: 'Gift Product Title Size' },
			{ from: '--font-size-sm', to: '--pidg-1-gift-gtd-fs', name: 'Gift Qtd Size' },
			{ from: '--font-size-sm', to: '--pidg-1-gift-desc-fs', name: 'Gift Description Size' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--pidg-1-text-fw', name: 'General Text' },
			{ from: '--font-weight-700', to: '--pidg-1-product-name-fw', name: 'Product Name' },
			{ from: '--font-weight-400', to: '--pidg-1-highlight-fw', name: 'Highlight' },
			{ from: '--font-weight-400', to: '--pidg-1-list-price-fw', name: 'List Price' },
			{ from: '--font-weight-700', to: '--pidg-1-price-fw', name: 'Price' },
			{ from: '--font-weight-400', to: '--pidg-1-discount-fw', name: 'Discount' },
			{ from: '--font-weight-400', to: '--pidg-1-installments-fw', name: 'Installments' },
			{ from: '--font-weight-400', to: '--pidg-1-sku-selector-fw', name: 'Sku Selector' },
			{ from: '--font-weight-700', to: '--pidg-1-cta-fw', name: 'CTA' },
			{ from: '--font-weight-700', to: '--pidg-1-freight-header-fw', name: 'Freight Head' },
			{ from: '--font-weight-400', to: '--pidg-1-freight-body-fw', name: 'Highlight Body' },
			{ from: '--font-weight-400', to: '--pidg-1-tipbar-fw', name: 'Tipbar' },
			{ from: '--font-weight-400', to: '--pidg-1-link-fw', name: 'Tipbar Link' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--pidg-1-text-ff', name: 'General Text' },
			{ from: '--main-font', to: '--pidg-1-product-name-ff', name: 'Product Name' },
			{ from: '--main-font', to: '--pidg-1-highlight-ff', name: 'Highlight' },
			{ from: '--main-font', to: '--pidg-1-list-price-ff', name: 'List Price' },
			{ from: '--main-font', to: '--pidg-1-price-ff', name: 'Price' },
			{ from: '--main-font', to: '--pidg-1-discount-ff', name: 'Discount' },
			{ from: '--main-font', to: '--pidg-1-installments-ff', name: 'Installments' },
			{ from: '--main-font', to: '--pidg-1-sku-selector-ff', name: 'Sku Selector' },
			{ from: '--main-font', to: '--pidg-1-cta-ff', name: 'CTA' },
			{ from: '--main-font', to: '--pidg-1-freight-header-ff', name: 'Freight Head' },
			{ from: '--main-font', to: '--pidg-1-freight-body-ff', name: 'Freight Body' },
			{ from: '--main-font', to: '--pidg-1-tipbar-ff', name: 'Tipbar' },
			{ from: '--main-font', to: '--pidg-1-link-ff', name: 'Tipbar Link' },
		],
	},
];

const tipBarDesktop = FlexLayoutRow({ blockClass: 'product-image-tipbar__pidg-1' }, [
	FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-1' }, [
		Image({
			blockClass: 'product-image-tipbar-image__pidg-1',
			src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060441889-cartao-tipbar-icon.png',
			maxHeight: 40,
			maxWidth: 40,
		}),
		RichText({
			blockClass: 'product-image-tipbar-text__pidg-1',
			text: 'Parcele sua compra em até 2 cartões de crédito',
		}),
	]),
	FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-1' }, [
		Image({
			src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
			blockClass: 'product-image-tipbar-image__pidg-1',
			maxHeight: 40,
			maxWidth: 40,
		}),
		RichText({
			blockClass: 'product-image-tipbar-text__pidg-1',
			text: 'Modalidade Compre online e retire na loja para CEPs selecionados',
		}),
	]),
	FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-1' }, [
		Image({
			src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060499860-whatsapp-tipbar-icon.png',
			blockClass: 'product-image-tipbar-image__pidg-1',
			maxHeight: 40,
			maxWidth: 40,
		}),
		RichText({
			blockClass: 'product-image-tipbar-text__pidg-1',
			text: 'Em caso de dúvidas, nossa equipe está te esperando no [WhatsApp](/)',
		}),
	]),
]);

const tipBarMobile = FlexLayoutRow(
	{ colSizing: 'auto', blockClass: 'product-image-tipbar__pidg-1-mobile', preventHorizontalStretch: true },
	[
		FlexLayoutRow(
			{ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-1', preventHorizontalStretch: true },
			[
				Image({
					src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060441889-cartao-tipbar-icon.png',
					blockClass: 'product-image-tipbar-image__pidg-1',
					maxHeight: 40,
					maxWidth: 40,
				}),
				RichText({
					blockClass: 'product-image-tipbar-text__pidg-1',
					text: 'Parcele sua compra em até 2 cartões de crédito',
				}),
			],
		),
		FlexLayoutRow(
			{ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-1', preventHorizontalStretch: true },
			[
				Image({
					src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
					blockClass: 'product-image-tipbar-image__pidg-1',
					maxHeight: 40,
					maxWidth: 40,
				}),
				RichText({
					blockClass: 'product-image-tipbar-text__pidg-1',
					text: 'Modalidade Compre online e retire na loja para CEPs selecionados',
				}),
			],
		),
		FlexLayoutRow(
			{ colSizing: 'auto', blockClass: 'product-image-tipbar-item__pidg-1', preventHorizontalStretch: true },
			[
				Image({
					src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060499860-whatsapp-tipbar-icon.png',
					blockClass: 'product-image-tipbar-image__pidg-1',
					maxHeight: 40,
					maxWidth: 40,
				}),
				RichText({
					blockClass: 'product-image-tipbar-text__pidg-1',
					text: 'Em caso de dúvidas, nossa equipe está te esperando no [WhatsApp](/)',
				}),
			],
		),
	],
);
